import { createSlice } from "@reduxjs/toolkit";
import { getContactList, saveContact, deleteContact } from "../controller/contact.controller";
import { Contact } from "../types/contactType";
import { SaveResponse } from "../types/common";

interface ContactState {
  loading: boolean;
  list: Contact[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: ContactState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {
    resetContactResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getContactList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getContactList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getContactList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data kontak";
      })
      .addCase(saveContact.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveContact.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan kontak";
      })
      .addCase(deleteContact.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetContactResponse } = contactSlice.actions;
export default contactSlice.reducer;
